<template>
  <v-app>
    <v-navigation-drawer
      floating
      app
      v-model="state.visibleMenu"
      style="border-right-color: rgba(255, 255, 255, 0.12); border-right-width: 1px; border-right-style: solid"
    >
      <v-list shaped>
        <v-list-item v-if="auth.state.signedIn">
          <v-list-item-avatar>
            <v-icon>{{ icons.mdiAccountCircle }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ auth.state.fullName }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="!auth.state.signedIn" link :to="{ name: 'sign-in' }">
          <v-list-item-avatar>
            <v-icon>{{ icons.mdiLogin }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>ログインする</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider />
      </v-list>
      <v-list shaped>
        <v-list-item-group color="primary">
          <template v-if="auth.state.signedIn">
            <v-list-item link :to="{ name: 'my-page' }">
              <v-list-item-action>
                <v-icon>{{ icons.mdiAccountCog }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>マイページ</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link :to="{ name: 'messages' }">
              <v-list-item-action>
                <v-icon>{{ icons.mdiForum }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>メッセージ</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <template v-if="auth.state.providerStatus == 'provider'">
              <v-subheader>トレーナー機能</v-subheader>
              <v-list-item link :to="{ name: 'provider-reservations' }">
                <v-list-item-action>
                  <v-icon>{{ icons.mdiListStatus }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>予約一覧</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item link :to="{ name: 'provider-reserve', params: { provider: auth.state.id } }">
                <v-list-item-action>
                  <v-icon>{{ icons.mdiYoga }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>代理予約</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item link :to="{ name: 'provider-reservations-calendar' }">
                <v-list-item-action>
                  <v-icon>{{ icons.mdiCalendarMonth }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>予約カレンダー</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item link :to="{ name: 'provider-calendar' }">
                <v-list-item-action>
                  <v-icon>{{ icons.mdiCalendarClock }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>営業時間管理</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item link :to="{ name: 'admin-provider' }">
                <v-list-item-action>
                  <v-icon>{{ icons.mdiNewspaper }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>記事管理</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <div v-if="auth.state.providerStatus != 'provider'">
              <v-subheader>予約</v-subheader>
              <v-list-item link :to="{ name: 'providers' }">
                <v-list-item-action>
                  <v-icon>{{ icons.mdiYoga }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>トレーナーを選ぶ</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item link :to="{ name: 'user-reservations' }">
                <v-list-item-action>
                  <v-icon>{{ icons.mdiListStatus }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>予約一覧</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
            <template v-if="auth.state.admin">
              <v-subheader>管理者機能</v-subheader>
              <v-list-item link :to="{ name: 'admin' }">
                <v-list-item-action>
                  <v-icon>{{ icons.mdiCogs }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>管理者画面</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item link :to="{ name: 'contact-messages' }">
                <v-list-item-action>
                  <v-icon>{{ icons.mdiFaceAgent }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>お問い合わせ確認</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item link :to="{ name: 'admin-provider-reservations-calendar' }">
                <v-list-item-action>
                  <v-icon>{{ icons.mdiCalendarMonth }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>予約カレンダー</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item link :to="{ name: 'admin-provider-calendar' }">
                <v-list-item-action>
                  <v-icon>{{ icons.mdiCalendarClock }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>営業時間管理</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-divider class="my-2" />
          </template>
          <ul class="pl-0">
            <v-list-item link :to="{ name: 'training-plan' }">
              <v-list-item-content>
                <v-list-item-title>
                  <li>トレーニングプラン</li>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <template v-if="!auth.state.signedIn">
              <v-list-item link :to="{ name: 'providers' }">
                <v-list-item-content>
                  <v-list-item-title>
                    <li>トレーナー一覧</li>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item link :to="{ name: 'price' }">
              <v-list-item-content>
                <v-list-item-title>
                  <li>料金</li>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link :to="{ name: 'articles' }">
              <v-list-item-content>
                <v-list-item-title>
                  <li>トレーナーブログ</li>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link :to="{ name: 'gallery' }">
              <v-list-item-content>
                <v-list-item-title>
                  <li>ギャラリー</li>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link :to="{ name: 'home', hash: '#access' }">
              <v-list-item-content>
                <v-list-item-title>
                  <li>アクセス</li>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link :to="{ name: 'faq' }">
              <v-list-item-content>
                <v-list-item-title>
                  <li>よくあるご質問</li>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link :to="{ name: 'contact' }">
              <v-list-item-content>
                <v-list-item-title>
                  <li>お問い合わせ</li>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </ul>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app class="bg-app-background-header">
      <v-app-bar-nav-icon
        @click.stop="state.visibleMenu = !state.visibleMenu"
        aria-label="ナビゲーションメニューを開く"
      />
      <img
        class="font-weight-bold mr-4"
        src="@/assets/img/logo.svg"
        height="50"
        width="176"
        style="cursor: pointer"
        @click="$router.push({ name: 'home' }).catch(() => {})"
        alt="CoCoDakara Body Design"
      />
      <v-spacer />

      <v-btn :to="{ name: 'providers' }" color="primary" outlined class="font-weight-bold mr-n3" exact>
        予約する
      </v-btn>
    </v-app-bar>

    <v-main class="mt-4" v-show="!hidden.state.enabled">
      <router-view />
      <v-footer class="footer translucent" padless absolute>
        <v-card class="transparent" flat tile width="100%">
          <v-card-text>
            <v-row class="my-1" justify="center">
              <v-btn text small class="mx-1" :to="{ name: 'terms-of-service' }" exact>利用規約</v-btn>
              <v-btn text small class="mx-1" :to="{ name: 'privacy-policy' }" exact>プライバシーポリシー</v-btn>
            </v-row>
            <v-row class="my-1" justify="center">
              <v-btn text small class="mx-1" :to="{ name: 'contact' }" exact>お問い合わせ</v-btn>
              <v-btn text small class="mx-1" :to="{ name: 'offer' }" exact>求人</v-btn>
              <v-btn text small class="mx-1" href="https://cocodakara.net" target="_blank" rel="noopener noreferrer">
                運営会社
              </v-btn>
            </v-row>
            <v-row class="my-1" justify="center">
              <v-btn text small class="mx-1" :to="{ name: 'training-plan' }" exact>トレーニングプラン</v-btn>
              <v-btn text small class="mx-1" :to="{ name: 'price' }" exact>料金</v-btn>
              <v-btn text small class="mx-1" :to="{ name: 'home' }" @click="toTop" exact>HOME</v-btn>
            </v-row>
            <v-row class="mt-3 mb-1" justify="center">
              <logo-btn
                class="mdi-instagram"
                href="https://www.instagram.com/cocodakara_bodydesign/"
                :icon="icons.mdiInstagram"
                aria-label="Instagram"
              />
              <logo-btn
                class="mdi-youtube"
                href="https://www.youtube.com/channel/UCdikwrks4VG6nKQjkA-52dw"
                :icon="icons.mdiYoutube"
                aria-label="Youtube"
              />
              <logo-btn
                class="mdi-twitter"
                href="https://twitter.com/CocodakaraD"
                :icon="icons.mdiTwitter"
                aria-label="twitter"
              />
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-text class="text-center">
            麻布十番・東麻布のパーソナルジム<br />
            CoCoDakara Body Design 麻布十番店<br />
            <small>(ココダカラ ボディデザイン)</small><br />
            東京都港区東麻布２丁目２２－５<br />
            麻布十番駅徒歩4分 / 赤羽橋駅徒歩4分
          </v-card-text>
        </v-card>
      </v-footer>
    </v-main>
    <v-fab-transition>
      <v-btn v-scroll="onScroll" v-show="state.scrollFab" fab dark fixed bottom right color="secondary" @click="toTop">
        <v-icon>{{ icons.mdiChevronUp }}</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-snackbar light v-model="snackbar.state.visible">
      {{ snackbar.state.text }}
      <template #action="{ attrs }">
        <v-btn small text v-bind="attrs" @click="snackbar.state.visible = false">
          <v-icon>{{ icons.mdiClose }}</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <div class="app-loading-overlay" role="status" aria-label="読み込み中">
      <span class="app-loading-spinner" aria-hidden="true" />
    </div>
    <v-overlay :value="error.state.enabled" opacity="0.90" z-index="301">
      <p>処理に失敗した可能性があります。</p>
      <p>予約などの操作を行った場合は、正常に完了しているかご確認ください。</p>
      <v-btn class="my-4" outlined block @click="reload()">再読み込み</v-btn>
      <v-btn v-if="auth.state.signedIn" class="my-4" outlined block href="/user-reservations">予約一覧</v-btn>
      <v-btn class="my-4" outlined block href="/">HOMEに戻る</v-btn>
    </v-overlay>
  </v-app>
</template>

<script lang="ts">
import { defineComponent, reactive, provide, getCurrentInstance, watch } from '@vue/composition-api';

import { Hub } from '@aws-amplify/core';
import { event as gtagEvent } from 'vue-gtag';

import { useAuth } from '@/compositions/auth';
import { useSnackbar } from '@/compositions/snackbar';
import { useLoading } from '@/compositions/loading';
import { useHidden } from '@/compositions/hidden';
import { useError } from '@/compositions/error';
import { useScreen } from '@/compositions/screen';

import authStore, { authStoreKey } from '@/stores/auth';
import snackbarStore, { snackbarStoreKey } from '@/stores/snackbar';
import loadingStore, { loadingStoreKey } from '@/stores/loading';
import hiddenStore, { hiddenStoreKey } from '@/stores/hidden';
import errorStore, { errorStoreKey } from '@/stores/error';
import mastersStore, { mastersStoreKey } from '@/stores/masters';

import goTo from 'vuetify/lib/services/goto';

const LogoBtn = () => import(/* webpackChunkName: "LogoBtn" */ '@/components/LogoBtn.vue');

import {
  mdiAccountCircle,
  mdiLogin,
  mdiAccountCog,
  mdiForum,
  mdiListStatus,
  mdiCalendarMonth,
  mdiCalendarClock,
  mdiYoga,
  mdiCogs,
  mdiFaceAgent,
  mdiInstagram,
  mdiYoutube,
  mdiTwitter,
  mdiClose,
  mdiReload,
  mdiChevronUp,
  mdiNewspaper,
} from '@mdi/js';

export default defineComponent({
  components: {
    LogoBtn,
  },
  setup() {
    provide(authStoreKey, authStore());
    provide(snackbarStoreKey, snackbarStore());
    provide(loadingStoreKey, loadingStore());
    provide(hiddenStoreKey, hiddenStore());
    provide(errorStoreKey, errorStore());
    provide(mastersStoreKey, mastersStore());

    const instance = getCurrentInstance();
    if (!instance) throw new Error(`instance`);

    const state = reactive({
      visibleMenu: false,
      reloadbar: false,
      reloading: false,
      scrollFab: false,
      registration: null as ServiceWorkerRegistration | null,
    });
    const icons = {
      mdiAccountCircle,
      mdiLogin,
      mdiAccountCog,
      mdiForum,
      mdiListStatus,
      mdiCalendarMonth,
      mdiCalendarClock,
      mdiYoga,
      mdiCogs,
      mdiFaceAgent,
      mdiInstagram,
      mdiYoutube,
      mdiTwitter,
      mdiClose,
      mdiReload,
      mdiChevronUp,
      mdiNewspaper,
    };

    const snackbar = useSnackbar();
    const loading = useLoading();
    const hidden = useHidden();
    const error = useError();
    const screen = useScreen();

    const setAppLoadingClass = (enabled: boolean): void => {
      if (typeof document === 'undefined') return;
      document.documentElement.classList.toggle('app-is-loading', enabled);
    };

    watch(() => loading.state.enabled, setAppLoadingClass, { immediate: true });

    const auth = useAuth();
    Hub.listen('auth', async (data) => {
      if (data.payload.event == 'signIn') {
        auth.loadAmplifyUser('email');
      } else if (data.payload.event == 'signUp') {
        gtagEvent('sign_up', { method: 'email' });
      }
    });
    auth.loadAmplifyUser('session');

    const onScroll = (event: { target: HTMLInputElement }): void => {
      if (typeof window === 'undefined') return;
      const top = window.pageYOffset || event.target.scrollTop || 0;
      state.scrollFab = top > 20;
    };

    const toTop = (): void => {
      goTo(0, { duration: 500 });
    };

    const reload = (): void => {
      window.location.reload();
    };

    return {
      state,
      icons,
      auth,
      snackbar,
      loading,
      hidden,
      error,
      screen,
      toTop,
      onScroll,
      reload,
    };
  },
  metaInfo: () => ({
    titleTemplate: '%s - 麻布十番・東麻布のパーソナルジム | CoCoDakara Body Design',
  }),
});
</script>

<style lang="scss">
:not(pre):not(code) {
  font-family: 'Helvetica Neue', 'Helvetica', 'Hiragino Sans', 'Hiragino Kaku Gothic ProN', 'Arial', 'Meiryo',
    sans-serif !important;
}
.v-note-wrapper {
  // mavon-editorがローディングとかの表に出るのを修正
  z-index: 1 !important;
}
.app-loading-overlay {
  align-items: center;
  background: rgba(33, 33, 33, 0.46);
  bottom: 0;
  display: none;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 300;
}
.app-is-loading .app-loading-overlay {
  display: flex;
}
.app-loading-spinner {
  animation: app-loading-spin 0.9s linear infinite;
  border: 5px solid rgba(255, 255, 255, 0.35);
  border-radius: 50%;
  border-top-color: #ffffff;
  height: 64px;
  width: 64px;
}
@keyframes app-loading-spin {
  to {
    transform: rotate(360deg);
  }
}
html {
  height: -webkit-fill-available;
}
body {
  min-height: 100vh;
  min-height: -webkit-fill-available;
}
amplify-authenticator {
  --container-height: 100%;
}
main {
  padding-bottom: 355px !important;
}
.footer {
  margin-bottom: -355px;
}
.translucent {
  background-color: black !important;
}
.full-card {
  padding-bottom: 30px;
}
.full-card-actions {
  position: absolute;
  bottom: 0;
  right: 0;
}
.v-menu__content {
  border: 0.5px solid;
  color: #ffbe00;
}
.v-select-list {
  background-color: #ffffff !important;
}
.v-select-list .v-list-item {
  color: #000000 !important;
}
.v-select-list .v-list-item--active .v-list-item__title {
  color: #000000 !important;
  font-weight: bold !important;
}
body,
.v-application {
  background: radial-gradient(circle at top right, rgba(60, 90, 140, 0.35), transparent 58%),
    radial-gradient(circle at bottom left, rgba(20, 35, 70, 0.28), transparent 64%),
    linear-gradient(180deg, #13233a 0%, #0b1422 55%, #06090f 100%) !important;
}
.bg-app-background-header {
  background: radial-gradient(circle at 85% 0%, rgba(120, 165, 210, 0.55), transparent 52%),
    radial-gradient(circle at 10% 85%, rgba(8, 12, 20, 0.65), transparent 60%),
    linear-gradient(180deg, #13233a 0%, #0c1625 60%, #080d14 100%) !important;
  position: relative;
  overflow: hidden;
}
.bg-app-background-header::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, rgba(255, 190, 0, 0) 0%, rgba(255, 190, 0, 0.85) 50%, rgba(255, 190, 0, 0) 100%);
  opacity: 0.8;
  pointer-events: none;
}
</style>
